import Api from './index';

const getResources = (bookId, params: any = {}) =>
  Api.get(`/books/${bookId}/resources`, { params });

const getSupportResources = () => Api.get('/support-resources', { params: { include: 'tags' } });

const getSupportResourcesForProduct = (productCurriculumId: number) =>
  Api.get('/support-resources', { params: { productCurriculumId, include: 'tags' } });

const getSupportResource = (resourceId: number) => Api.get(`/support-resources/${resourceId}`);

const getApplicationResources = (applicationId: string) =>
  Api.get(`/applications/${applicationId}/resources`);

export {
  getResources,
  getSupportResources,
  getSupportResourcesForProduct,
  getSupportResource,
  getApplicationResources
};
